import { getEnvVar } from './utils/envs/getEnvVar';

// See: https://vercel.com/takeda/exp-marketplace-initial/settings/environment-variables
export type EnvName = 'local' | 'development' | 'staging' | 'production';
const envName = getEnvVar(() => process.env.NEXT_PUBLIC_MARKETPLACE_ENV) as EnvName;

// See: https://nextjs.org/docs/basic-features/environment-variables
export const env = {
	name: envName,
	isProduction: envName === 'production',
	isLocal: envName === 'local',
	formioSearchFeedback: getEnvVar(() => process.env.NEXT_PUBLIC_FORMIO_SEARCH_FEEDBACK),
	procurementApiUrl: getEnvVar(() => process.env.NEXT_PUBLIC_PROCUREMENT_API_ENDPOINT),
	procurementStatusUrl: getEnvVar(() => process.env.NEXT_PUBLIC_PROCUREMENT_STATUS_URL),
	orgExplorerApiUrl: getEnvVar(() => process.env.NEXT_PUBLIC_ORG_EXPLORER_ENDPOINT),
	orgExplorerNewApiUrl: getEnvVar(() => process.env.NEXT_PUBLIC_ORG_EXPLORER_NEWENDPOINT),
	orgExplorerApiKey: getEnvVar(() => process.env.ORG_EXPLORER_API_KEY),
	marketplaceApiUrl: getEnvVar(() => process.env.NEXT_PUBLIC_MARKETPLACE_ENDPOINT),
	mdgBaseUrl: getEnvVar(() => process.env.NEXT_PUBLIC_MDG_BASE_URL),
	build: {
		time: process.env.APP_BUILD_TIME || '',
		version: process.env.APP_VERSION || '',
	},
	aad: {
		tenantId: getEnvVar(() => process.env.NEXT_PUBLIC_AZURE_AD_TENANT_ID),
		clientId: getEnvVar(() => process.env.NEXT_PUBLIC_AZURE_AD_CLIENT_ID),
		clientSecret: getEnvVar(() => process.env.AZURE_AD_CLIENT_SECRET),
		e2e: {
			clientId: getEnvVar(() => process.env.NEXT_PUBLIC_AZURE_AD_E2E_CLIENT_ID),
			clientSecret: getEnvVar(() => process.env.AZURE_AD_E2E_CLIENT_SECRET),
		},
	},
	algolia: {
		indexes: {
			stores: getEnvVar(() => process.env.NEXT_PUBLIC_ALGOLIA_STORES_INDEX),
			categories: getEnvVar(() => process.env.NEXT_PUBLIC_ALGOLIA_CATEGORIES_INDEX),
			subCategories: getEnvVar(() => process.env.NEXT_PUBLIC_ALGOLIA_SUBCATEGORIES_INDEX),
			products: getEnvVar(() => process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_INDEX),
			productsSuggestions: getEnvVar(
				() => process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_SUGGESTIONS_INDEX,
			),
			productsPopular: getEnvVar(() => process.env.NEXT_PUBLIC_ALGOLIA_PRODUCTS_POPULAR_INDEX),
			concepts: getEnvVar(() => process.env.NEXT_PUBLIC_ALGOLIA_CONCEPTS_INDEX),
		},
		procurementIndexes: {
			// todo: remove suppliers after full migration to AWS
			// don't use index nave from env — use getSupplierIndexName() instead
			suppliers: getEnvVar(() => process.env.NEXT_PUBLIC_ALGOLIA_SUPPLIERS_INDEX),
			suppliersSuggestions: getEnvVar(
				() => process.env.NEXT_PUBLIC_ALGOLIA_SUPPLIERS_SUGGESTIONS_INDEX,
			),
			awsSuppliers: getEnvVar(() => process.env.NEXT_PUBLIC_ALGOLIA_SUPPLIERS_AWS_INDEX),
			awsSuppliersSuggestions: getEnvVar(
				() => process.env.NEXT_PUBLIC_ALGOLIA_SUPPLIERS_AWS_SUGGESTIONS_INDEX,
			),
		},
		appId: getEnvVar(() => process.env.NEXT_PUBLIC_ALGOLIA_APP_ID),
		appKey: getEnvVar(() => process.env.ALGOLIA_API_KEY),
		ariba: {
			indexAlias: getEnvVar(() => process.env.NEXT_PUBLIC_ALGOLIA_ARIBA_INDEX_ALIAS),
			appId: getEnvVar(() => process.env.NEXT_PUBLIC_ALGOLIA_ARIBA_APP_ID),
			appKey: getEnvVar(() => process.env.ALGOLIA_ARIBA_API_KEY),
		},
	},
	api: {
		favorites: {
			endpoint: getEnvVar(() => process.env.NEXT_PUBLIC_FAVORITES_ENDPOINT),
			appKey: getEnvVar(() => process.env.NEXT_PUBLIC_FAVORITES_APP_KEY),
		},
	},
	suppliersApi: {
		// todo: remove api and key after full migration to AWS
		api: getEnvVar(() => process.env.SUPPLIERS_API_ENDPOINT),
		key: getEnvVar(() => process.env.SUPPLIERS_API_KEY),
		awsBaseUrl: getEnvVar(() => process.env.SUPPLIER_API_AWS_BASE_URL),
		awsKey: getEnvVar(() => process.env.SUPPLIER_API_AWS_KEY),
		useAws: Boolean(process.env.NEXT_PUBLIC_SUPPLIER_USE_AWS),
		contractNotifications: {
			apiBaseUrl: getEnvVar(() => process.env.SUPPLIER_CONTRACT_NOTIFICATIONS_API_BASE_URL),
			apiKey: getEnvVar(() => process.env.SUPPLIER_CONTRACT_NOTIFICATIONS_API_KEY),
		},
	},
	azure: {
		connectionString: getEnvVar(() => process.env.NEXT_PUBLIC_AZURE_APP_INSIGHTS_CONNECTION_STRING),
	},
	cloudinary: {
		cloudName: getEnvVar(() => process.env.NEXT_PUBLIC_CLOUDINARY_CLOUDNAME),
	},
	configcat: {
		configcatKey: getEnvVar(() => process.env.NEXT_PUBLIC_CONFIGCAT_KEY),
		devConfigcatKey: getEnvVar(() => process.env.NEXT_PUBLIC_DEV_CONFIGCAT_KEY),
		testConfigcatFlag: getEnvVar(() => process.env.NEXT_PUBLIC_TEST_CONFIGCAT_FLAG),
	},
	sanity: {
		projectId: getEnvVar(() => process.env.SANITY_PROJECT_ID),
		dataset: getEnvVar(() => process.env.SANITY_DATASET),
		token: getEnvVar(() => process.env.SANITY_TOKEN),
	},
	geoServiceUrl: getEnvVar(() => process.env.NEXT_PUBLIC_GEO_SERVICE_URL),
	ownApi: {
		secret: getEnvVar(() => process.env.OWN_API_SECRET),
	},
	qa: {
		testUsers: getEnvVar(() => process.env.NEXT_PUBLIC_TEST_USERS),
	},
};
